/* Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import {
  useBusinessContextsSimpleQuery,
  useGetPrimaryBcQuery,
} from "~/generated/graphql";
import { isNotNil } from "~/tools";

export function useBusinessContexts() {
  const {
    data: businessContextData,
    loading: isBusinessContextLoading,
    error: businessContextError,
  } = useBusinessContextsSimpleQuery();

  const {
    data: primaryBusinessContextData,
    loading: isPrimaryBusinessContextLoading,
    error: primaryBusinessContextError,
  } = useGetPrimaryBcQuery();

  const businessContexts = React.useMemo(
    () =>
      businessContextData?.businessContexts?.businessContexts
        ?.filter(isNotNil)
        .map(({ id, name }) => ({
          label: name,
          value: id,
        })) ?? [],
    [businessContextData]
  );

  const primaryBusinessContextId =
    primaryBusinessContextData?.primaryBusinessContext?.id ?? "";

  return {
    businessContexts,
    primaryBusinessContextId,
    loading: isBusinessContextLoading ?? isPrimaryBusinessContextLoading,
    error: businessContextError ?? primaryBusinessContextError,
  };
}
